export * from './objekt-entfernt.interface';
